<template>
    <div class="container">
        <h1 class="page-title h1 mt-4">Użytkownicy sklepowi</h1>
        <div class="d-flex justify-content-end">
            <router-link
                class="btn btn-secondary m-1"
                to="add-store-user"
                id="add-store-user"
            >
                <a-icon icon="Plus" width="15px" height="15px" class="mr-2" />
                Dodaj użytkownika sklepowego
            </router-link>
        </div>
        <div>
            <page-preloader
                v-if="storeUsersStatus === 'loading'"
            ></page-preloader>
            <div v-else-if="userStoresTableData && userStoresTableData.body">
                <ui-data-table
                    class="store-users"
                    trSpacing
                    headersOnMobile
                    mobileBreakpoint="lg"
                    :tableData="userStoresTableData"
                />
            </div>
            <div v-else>
                Brak danych.
            </div>
        </div>
    </div>
</template>

<script>
import PagePreloader from '@/components/global/ui/PagePreloader.vue'
import StoreUsersEditBtn from '@/components/settings/storeUsersManagement/StoreUsersEditBtn.vue'
import StoreUserShops from '@/components/settings/storeUsersManagement/StoreUserShops'
import StoreUserPermissions from '@/components/settings/storeUsersManagement/StoreUserPermissions'

export default {
    name: 'UserStores',
    components: {
        PagePreloader
    },
    computed: {
        usersStoreData() {
            return this.$store.getters.getStoreUsers
        },
        storeUsersStatus() {
            return this.$store.getters.getStoreUsersStatus
        },
        userStoresTableData() {
            const head = [
                'Login',
                'Nazwa',
                'Sklepy',
                { text: 'Uprawnienia', tooltip: 'Możesz zmienić uprawnienia przy edycji użytkownika' },
                ''
            ]
            const body =
                this.usersStoreData &&
                this.usersStoreData.length &&
                this.usersStoreData.map(user => {
                    return [
                        {
                            text: user.login,
                            customClass: 'text-primary',
                            style: {
                                'font-weight': '500',
                                'min-width': '90px'
                            }
                        },
                        {
                            text: user.userAlias || '-',
                            customClass: 'text-primary',
                            style: { 'max-width': '300px' }
                        },
                        {
                            type: 'component',
                            component: StoreUserShops,
                            config: {
                                data: user.shops
                            }
                        },
                        {
                            type: 'component',
                            component: StoreUserPermissions,
                            config: {
                                permissions: user.userPermissions,
                                isEditable: false
                            }
                        },
                        {
                            style: {
                                'font-size': '1.15em',
                                'font-weight': '500',
                                'overflow-wrap': 'normal'
                            },
                            type: 'component',
                            component: StoreUsersEditBtn,
                            config: {
                                login: user.login,
                                id: user.id,
                                userAlias: user.userAlias,
                                userPermissions: user.userPermissions
                            }
                        }
                    ]
                })
            return { head, body }
        }
    },
    created() {
        this.fetch()
    },
    methods: {
        fetch() {
            this.$store.dispatch('storeUsersFetch')
        }
    }
}
</script>
